import React from 'react';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// Components
import CTALogsTable from './CTALogsTable';

export default function CTALogList() {
  return (
    <Row>
      <Col>
        <CTALogsTable />
      </Col>
    </Row>
  );
}
